import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { imageDb } from '../api/firebase-config';

const uploadFile = (
  file: File,
  path: string,
  onProgress: (progress: number) => void,
  onSuccess: (url: string) => void,
  onError: (error: Error) => void
) => {
  const storageRef = ref(imageDb, path);
  const uploadTask = uploadBytesResumable(storageRef, file);

  uploadTask.on(
    'state_changed',
    (snapshot) => {
      const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      onProgress(progress);
    },
    (error) => {
      onError(error);
    },
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        onSuccess(downloadURL);
        onProgress(0);
      });
    }
  );
};

export default uploadFile;
